<div kalDialogContent>
    <div class="flexLine date">
        <kal-form-field class="date-heure">
            <kal-datepicker [formControl]="dateSelectedControl"
                            [label]="dateSelectedLabel">
            </kal-datepicker>
        </kal-form-field>
    </div>
</div>

<div kalDialogFooter>
    <div class="gup-C-validationArea gup-O-list">
        <div class="gup-O-list__item">
            <kal-button (click)="submit()"
                        [disabled]="dateSelectedControl.invalid"
                        kalTheme="primary">
                Valider
            </kal-button>
        </div>
        <div class="gup-O-list__item">
            <kal-button (click)="close()"
                        kalTheme="secondary">
                Annuler
            </kal-button>
        </div>
    </div>

</div>
